import { get, post } from '../request';

export async function fetchPreference(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/equityfinder`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function persistPreference(
  { userService },
  authenticationToken,
  { userId, data },
) {
  const url = `${userService}/trueprodigy/user/${userId}/preference/equityfinder`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function refreshCache(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/rediscache/refresh`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function checkIsChildProperty(
  { equityfinderService },
  authenticationToken,
  { payload: { propertyId, year } },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/ischild`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSystemConfiguration(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/configuration/systemsettings`;
  const { body } = await get(authenticationToken, url);
  return body;
}
